import sanitizeHtml from "sanitize-html";
import Drawer from 'react-modern-drawer'
import { useDispatch, useSelector } from 'react-redux';
import { setPopup, update_messages, removeMessage } from '../../../redux/messageSlice';
import { useMutation } from '@apollo/client';
import { Flagged_UnFlagged_Mutation } from '../../../apollo/Mutations';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import EmojiContainer from "./EmojiContainer";

const MessageDrawer = () => {
    const { slug, filter_name, ...params } = useParams()
    console.log(params);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user, allUsers, active_msg, reply_main_msg, msg_drawer } = useSelector(state => state.message)

    const handleOpen = (type) => {
        if (type === 'editMessage') {
            dispatch(setPopup({ key: 'editMsg_popup', value: true }))
        }
        else if (type === 'reply') {
            navigate(`/connect/${slug}/reply/${active_msg?.msg_id}`) //{ state: { msg: active_msg } }
            // setReplayMessageContainer(true);
        }
        else if (type === 'editTitle') {
            // setTitleEdit(true);
            dispatch(setPopup({ key: 'title_popup', value: { key: 'msg_title', state: true } }))
        } else if (type === 'deleteMessage') {
            dispatch(setPopup({ key: 'delete_msg', value: true }))
        } else if (type === 'forwardMessage') {
            dispatch(setPopup({ key: 'userList', value: { state: true, key: 'forward' } }))
        }
        //  else if (type === 'emojiView') {
        //     setEmojiView(true);
        // }
        dispatch(setPopup({ key: 'msg_drawer', value: false }))
    }

    const sender = allUsers?.filter(u => active_msg?.sender === u.id)?.[0]
    console.log("🚀 ~ MessageOptions ~ active_msg:", active_msg)

    const copyToClipBoard = () => {
        let msgBody = sanitizeHtml(active_msg?.msg_body.replace(/```html|```/g, '').trim(), {
            allowedTags: [],
            allowedAttributes: {},
            allowedIframeHostnames: [],
        });
        navigator.clipboard.writeText(msgBody);
        toast.success('Already Copied')
        dispatch(setPopup({ key: 'msg_drawer', value: false }))
    };

    const [updateFlagUnFlag] = useMutation(Flagged_UnFlagged_Mutation)
    const flag_action = async () => {
        updateFlagUnFlag({
            variables: {
                input: {
                    conversation_id: active_msg?.conversation_id,
                    msg_id: active_msg?.msg_id,
                    is_add: active_msg?.has_flagged?.indexOf(user?.id) > -1 ? 'no' : 'yes'
                }
            }

        });
        if (filter_name && filter_name === 'flag') {
            dispatch(removeMessage(active_msg))
        } else {
            dispatch(
                update_messages({
                    conversation_id: active_msg?.conversation_id,
                    msg_id: active_msg?.msg_id,
                    fields: {
                        has_flagged: active_msg?.has_flagged?.indexOf(user?.id) > -1 ? [] : [user?.id]
                    },
                    is_reply_msg: reply_main_msg ? 'yes' : 'no',
                    msg_type: active_msg?.msg_type
                })
            )
        }
        dispatch(setPopup({ key: 'msg_drawer', value: false }))
    }


    return (
        <>
            <Drawer
                open={msg_drawer}
                onClose={() => dispatch(setPopup({ key: 'msg_drawer', value: false }))}
                direction='bottom'
                enableOverlay={true}
                className='rounded-lg !-bottom-3 !h-auto px-4 dark:!bg-teal-600'
                overlayClassName='customOverlay'
            >
                <div className=''>
                    <div className="appBar "></div>
                    <div className='topFloatOptCon'>
                        <div className="homeViewRoomImg" attr-type="opt_hidden">
                            <div className="sender_img nameL">
                                <span className="nameLetters">{sender?.fnln}</span>
                            </div>
                        </div>
                        <div><p className="homeViewImgText dark:text-white">{active_msg?.sendername}</p></div>
                        <div className="homeFloatContainer">
                            <div className="topFloatOpts" onClick={() => handleOpen("emojiView")}>
                                {/* <div className='w-6 h-6 relative'>
                                    <span className='emojiIconsGray absolute'></span>
                                </div>
                                <div className='ml-2'>
                                    <span className="homeFloatText dark:text-white" >Emoji</span>
                                </div> */}
                                <EmojiContainer />
                            </div>

                            {!params.msg_id &&
                                <div className="topFloatOpts" onClick={() => flag_action()}>
                                    {active_msg?.has_flagged.includes(user?.id) ?
                                        <div className='w-6 h-6 relative'>
                                            <span className='unflagIconsGray absolute'></span>
                                        </div> :
                                        <div className='w-6 h-6 relative'>
                                            <span className='flagIconsGray absolute'></span>
                                        </div>
                                    }
                                    <div>
                                        <span className="homeFloatText dark:text-white ml-2" >{active_msg?.has_flagged.includes(user?.id) ? 'Unflag' : 'Flag'}</span>
                                    </div>
                                </div>
                            }
                            {!params.msg_id &&
                                <div className="topFloatOpts" onClick={() => handleOpen("reply")}>
                                    <div className='w-6 h-6 relative'>
                                        <span className='replayIconsGray absolute'></span>
                                    </div>

                                    <div>
                                        <span className="homeFloatText dark:text-white ml-2" >Reply</span>
                                    </div>
                                </div>
                            }

                            <div className="topFloatOpts" onClick={() => handleOpen("forwardMessage")}>
                                <div className='w-6 h-6 relative'>
                                    <span className='forwardIconsGray absolute'></span>
                                </div>
                                <div>
                                    <span className="homeFloatText dark:text-white ml-2" >Forward</span>
                                </div>
                            </div>

                            <div className="topFloatOpts" onClick={copyToClipBoard}>
                                <div className='w-6 h-6 relative'>
                                    <span className='copyIconsGray absolute'></span>
                                </div>
                                <div>
                                    <span className="homeFloatText dark:text-white ml-2">Copy</span>
                                </div>
                            </div>
                            {active_msg?.sender === user?.id &&
                                <div className="topFloatOpts" onClick={() => handleOpen("editTitle")}>
                                    <div className='w-6 h-6 relative'>
                                        <span style={{ backgroundSize: '20px' }} className='addTitleGray absolute'></span>
                                    </div>
                                    <div>
                                        <span className="homeFloatText dark:text-white ml-2" >Add message title</span>
                                    </div>
                                </div>
                            }

                            {(!params.msg_id && active_msg?.sender === user?.id) &&
                                <div className="topFloatOpts" onClick={() => handleOpen("editMessage")}>
                                    <div className='w-6 h-6 relative'>
                                        <span style={{ backgroundSize: '22px' }} className='messageEditGray absolute'></span>
                                    </div>

                                    <div>
                                        <span className="homeFloatText dark:text-white ml-2" >Message Edit</span>
                                    </div>
                                </div>
                            }

                            <div className="topFloatOpts" onClick={() => handleOpen("deleteMessage")} >
                                <div className='w-6 h-6 relative'>
                                    <span style={{ backgroundSize: '22px' }} className='messageDeleteGray -top-0.5 absolute'></span>
                                </div>
                                <div>
                                    <span className="deleteTextDark dark:text-white ml-2" >Delete Message</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    );
};

export default MessageDrawer;